export const taskFeedbackKpiGroups = [
  {
    title: "Hard facts",
    description: "Operational estimates for the selected tasks.",
    kpis: [
      { id: "monthly_frequency", title: "Cases/year", question: "How often is the task performed?", options: ["Less frequently", "Monthly", "Weekly", "Several times a week", "Daily"] },
      { id: "avg_case_time_seconds", title: "Avg. time/case", question: "How long does a typical case take?", options: ["Less than 5 minutes", "5–15 minutes", "15–60 minutes", "1–2 hours", "More than 2 hours"] },
      { id: "standard_case_share", title: "Standard cases", question: "How often does the standard process apply?", options: ["0–10%", "10–30%", "30–70%", "70–90%", "90–100%"] },
      { id: "rework_share", title: "Rework share", question: "How often is correction or repetition needed?", options: ["0–10%", "10–30%", "30–50%", "50–70%", "70–100%"] },
      { id: "communication_outside_system_share", title: "Offline comms", question: "How much coordination happens outside the system?", options: ["0–10%", "10–30%", "30–50%", "50–70%", "70–100%"] },
    ],
  },
  {
    title: "Soft facts",
    description: "Perceived quality and improvement potential.",
    kpis: [
      { id: "pain_level", title: "Pain level", question: "How frustrating or effort-intensive is the task?", options: ["Very low", "Low", "Moderate", "High", "Very high"] },
      { id: "business_criticality", title: "Business criticality", question: "How important is it for daily operations?", options: ["Low", "Limited", "Moderate", "High", "Critical"] },
      { id: "input_standardization", title: "Input standardization", question: "How structured and consistent are the inputs?", options: ["Always the same", "Often the same", "Partly the same", "Partly variable", "Very variable"] },
      { id: "perceived_value", title: "Perceived value", question: "How valuable is the task outcome?", options: ["Very low", "Low", "Moderate", "High", "Very high"] },
    ],
  },
];

export const taskFeedbackKpis = taskFeedbackKpiGroups.flatMap((group) => group.kpis);
export const taskFeedbackTopics = ["Unnecessary effort", "Errors / rework", "System waiting time", "Waiting for colleagues", "Manual workaround"];
export const taskFeedbackTimeShares = ["<10%", "10-25%", "25-50%", ">50%"];
export const taskFeedbackOccurrences = ["Rarely", "Sometimes", "Often", "Almost always"];
